var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper",style:({
    width: _vm.width ? `${_vm.width}px` : 'auto',
    height: _vm.height ? `${_vm.height}px` : 'auto',
  })},[_c('img',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.status === _vm.StatusEnum.LOADED),expression:"status === StatusEnum.LOADED"}],ref:"img",attrs:{"alt":_vm.alt}},_vm.$listeners)),_vm._v(" "),_vm._t("loading"),_vm._v(" "),(_vm.status === _vm.StatusEnum.FAILED)?_vm._t("failed",function(){return [_c('Empty',_vm._b({},'Empty',_vm.emptyInfo,false))]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }